import axios from 'axios';

const updateSmallTalkResponses = (smallTalkId, params) => {
  return axios.put(`smalltalk/${smallTalkId}/responses`, params);
};

export { updateSmallTalkResponses };
